export function createTransitionController({
  setTimer = globalThis.setTimeout?.bind(globalThis),
  clearTimer = globalThis.clearTimeout?.bind(globalThis)
} = {}) {
  const pending = new Map();

  function cancel(key) {
    const timer = pending.get(key);
    if (timer !== undefined) {
      clearTimer?.(timer);
      pending.delete(key);
    }
  }

  function schedule(key, { delay = 0, guard = () => true, run }) {
    cancel(key);
    const timer = setTimer(() => {
      pending.delete(key);
      if (guard()) run();
    }, delay);
    pending.set(key, timer);
    return timer;
  }

  function cancelAll() {
    for (const key of [...pending.keys()]) cancel(key);
  }

  return { schedule, cancel, cancelAll, has: key => pending.has(key) };
}

export const liveTransitions = createTransitionController();
